import { PaginatedFieldsProvider } from '@cibo/landmanager'
import { Stack } from '@mui/material'
import { UserFields } from 'pages/UserProfile'

export const OrganizationUser = () => {
  return (
    <Stack>
      <PaginatedFieldsProvider>
        <UserFields />
      </PaginatedFieldsProvider>
    </Stack>
  )
}
